import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-date-range-config',
  templateUrl: './d-date-range-config.component.html',
  styles: []
})
export class DDateRangeConfigComponent extends DynamicComponentBase {
  static KEY = 'd-date-range-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    // if (!Array.isArray(config.value)) {
    //   config.value = [];
    // }
  }
}
